import countriesServiceGen from "./generated/countriesServiceGen";

class countriesService extends countriesServiceGen {
}

export default countriesService;